import { motion } from "framer-motion";
import SectionTitle from "../../Components/SectionTitle/SectionTitle";
import MarqueeCards from "../../Components/SkillCards/MarqueeCards";
import SkillsCards from "../../Components/SkillCards/SkillCards";
import { fadeIn, staggerContainer } from "../../Constants/FramerMotions";
import "./skills.scss";

const Skills = () => {
  return (
    <motion.div
      className="skills-container"
      id="Skills"
      variants={staggerContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.25 }}
    >
      <div className="skills-header">
        <motion.div
          variants={fadeIn("right", "tween", 0.1, 0.4)}
          style={{ width: "100%" }}
        >
          <SectionTitle title="Skills" subtitle="What I Do" />
        </motion.div>
      </div>

      <motion.div
        className="marquee-skills-cards-wrapper"
        variants={fadeIn("left", "tween", 0, 0.4)}
      >
        <div className="relative">
          <div
            className="absolute top-[45px] w-full h-[1px]"
            style={{ background: "#fcc40f" }}
          ></div>
          <MarqueeCards direction="left">
            <SkillsCards />
          </MarqueeCards>
        </div>
        <div className="relative">
          <div
            className="absolute top-[45px] w-full h-[1px]"
            style={{ background: "#fcc40f" }}
          ></div>
          <MarqueeCards direction="right">
            <SkillsCards />
          </MarqueeCards>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default Skills;
